import axiosInstance from '../../../util/axiosInstance';

import { getToken } from "../../../util/Cookies";

export const fetchserviceitems = async () => {
    try {
        const token = getToken();
        const response = await axiosInstance.get('/tent-house/services', {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error('Network response was not ok');
        }
    } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
    }
};


export const fetchserviceitemssecond = async () => {
    try {
        const token = getToken();
        const response = await axiosInstance.get('/v1/tent-house/services', {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
        console.log("response",response)
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error('Network response was not ok');
        }
    } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
    }
};
export const fetchCuisineTypes = async () => {
    try {
        const token = getToken(); // Ensure this returns the JWT token
        const response = await axiosInstance.get('/cuisine/cuisine-types', {
           headers: {
              Authorization: `Bearer ${token}`,
              Accept: 'application/json'
            }

        });

        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error('Network response was not ok');
        }
    } catch (error) {
        console.error('There was a problem fetching cuisine types:', error);
    }
};

export const fetchCuisineMasters = async (mealId) => {
    try {
        const token = getToken();
        const url = mealId 
          ? `/catering-items/cuisine-masters?mealId=${mealId}` 
          : '/catering-items/cuisine-masters';
          
        const response = await axiosInstance.get(url, {
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
            }
        });
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error('Network response was not ok');
        }
    } catch (error) {
        console.error('There was a problem fetching cuisine masters:', error);
    }
};


export const fetchMealsType = async () => {
    try {
        const token = getToken(); // This should return the valid JWT token

        const response = await axiosInstance.get('/cuisine/meals-type', {
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json',
            }
        });

        if (response.status === 200) {
            const meals = response.data;

            // Extract only meal_id and meal_name
            return meals.map((meal) => ({
                meal_id: meal.meal_id,
                meal_name: meal.meal_name
            }));
        } else {
            throw new Error('Network response was not ok');
        }
    } catch (error) {
        console.error('There was a problem fetching meals type:', error);
    }
};

export const fetchCuisineCategories = async () => {
    try {
        const token = getToken(); // your JWT token logic

        const response = await axiosInstance.get('/cuisine/categories', {
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json',
            }
        });

        return response.data; // full raw response
    } catch (error) {
        console.error('Error fetching cuisine categories:', error);
    }
};